// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface ControlCrossOverIconSignature {
  Element: SVGSVGElement;
}

export const ControlCrossOverIcon: TOC<ControlCrossOverIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path d="M19.707 10.707L23.414 7L19.707 3.293L18.293 4.707L19.586 6H17C14.006 6 12.1 8.086 10.5 10.275C8.9 8.086 6.994 6 4 6H0V8H4C6.275 8 7.772 9.874 9.276 12C7.772 14.126 6.275 16 4 16H0V18H4C6.994 18 8.9 15.914 10.5 13.725C12.1 15.914 14.006 18 17 18H19.586L18.293 19.293L19.707 20.707L23.414 17L19.707 13.293L18.293 14.707L19.586 16H17C14.725 16 13.228 14.126 11.724 12C13.228 9.874 14.725 8 17 8H19.586L18.293 9.293L19.707 10.707Z"/>
</svg>
</template>;